import { render } from "./IconFilter.vue?vue&type=template&id=673519a1"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconFilter.vue"]])

export default __exports__